// extracted by mini-css-extract-plugin
export default {"container":"LoadingSkeleton_container__zqCl+"};